import User16 from '@carbon/icons-react/es/user/16';
import { ICellRendererParams } from 'ag-grid-community';
import React, { useMemo } from 'react';
import { UserTag } from 'components/atoms/select';
import { useGetUserFromIndexedDb } from 'hooks/use-idb';
import { useTranslate } from 'hooks/use-translation';
import { fullName } from 'utils/full-name';
import { getRandomColor } from 'utils/get-random-color';
import { emptyState } from './cell-renderer';

export const CreatedByRenderer = (params: ICellRendererParams) => {
  const {
    data = {},
    node: { group = false },
  } = params;

  const { createdBy, createdAt } = data;

  const translate = useTranslate();
  const user = useGetUserFromIndexedDb(createdBy);
  const createdByUser = useMemo(() => {
    if (createdAt) {
      if (!user) {
        const anonymousText = translate('anonymous');

        return <UserTag color="gray" icon={<User16 />} label={anonymousText} />;
      }

      if (user) {
        return (
          <UserTag
            color={getRandomColor(user?.userId)}
            imageUrl={user.photoUrl}
            label={fullName(user)}
          />
        );
      }

      return undefined;
    }

    return undefined;
  }, [createdAt, translate, user]);

  if (group) {
    return null;
  }

  if (createdByUser) {
    return createdByUser;
  }

  return emptyState;
};
